<script lang="ts">
    export let type: 'h1' | 'h2' | 'h3';
</script>

<svelte:element this="{type}" class="kp-heading heading-{type}" {...$$restProps}>
    <slot/>
</svelte:element>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-heading {
        margin: 0;
        padding: 0;
        font-weight: 500;

        &.heading-h1 {
            font-size: @font-size-xxl;
        }

        &.heading-h2 {
            font-size: @font-size-xl;
        }

        &.heading-h3 {
            font-size: @font-size-default;
        }
    }
</style>